import { Injectable } from '@angular/core';
import { XMLParser, XMLBuilder } from 'fast-xml-parser';

@Injectable({ providedIn: 'root' })
export class XmlUtilService {
  private readonly parser = new XMLParser({
    ignoreAttributes: false,
    attributeNamePrefix: '',
    removeNSPrefix: true,          // drops “per:Foo” → “Foo”
    ignoreDeclaration: true
  });

  private readonly builder = new XMLBuilder({
    ignoreAttributes: false,
    attributeNamePrefix: '',
    suppressEmptyNode: true
  });

  /** Convert raw XML string → plain JS/JSON object */
  // This method is used to xml to json using xml
  xmlToJson<T = any>(xml: string): T {
    return this.parser.parse(xml) as T;
  }

  /** Convert JS/JSON object → XML string */
  // This method is used to json to xml using obj
  jsonToXml(obj: unknown): string {
    return this.builder.build(obj);
  }
}
